// How a project identifies itself on a document header.
//
// The submittal, RFI and change-order generators each print two things: the
// company's job/file number and the project name. Until 2026-07-30 all three
// dug the number out of the project NAME with the regex (\d{2}TM\d{3}) — the
// format of one company, Trade Mark Masonry, whose internal app this product
// forked from. Every other tenant printed a blank job number and an
// un-shortened name.
//
// The number now lives in projects.job_number (migration
// 20260730220000_projects_job_number), free text, each tenant's own format.

/** The company's job/file number for this project, or '' when unset. */
export function jobNumber(project) {
  return String((project && project.job_number) || '').trim();
}

/**
 * The project name as a document header should print it.
 *
 * Names are commonly stored as "<job number> - <name>" ("23TM001 - Richards
 * and Drake", "NG-2601 - Riverside Community Centre"). When the header prints
 * the number in its own field, repeating it in the name reads as a mistake, so
 * strip that prefix — but only the project's OWN number, never a guessed
 * pattern. A project with no number, or whose name does not open with it,
 * comes back untouched.
 */
export function displayName(project) {
  const name = String((project && project.name) || '').trim();
  const num  = jobNumber(project);
  if (!num) return name;
  const escaped = num.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const stripped = name.replace(new RegExp('^\\s*' + escaped + '\\s*-\\s*'), '').trim();
  return stripped || name;
}
